import commonBlocks from '../Common';
import {UnderwritingBlock} from '../Common/UnderwritingBlock';
import {AvailablePlans, BlocksMap, FormBlock} from '../types';
import {AdditionalOptionsandBenefitsGCI5Block} from './AdditionalOptionsandBenefitsGCI5';
import {AdditionalOptionsandBenefitsGVCI4Block} from './AdditionalOptionsandBenefitsGVCI4';
import {BenefitScheduleBlock} from './BenefitScheduleBlock';
import {CancerConditionsBlock} from './CancerCondition';
import {CancerConditionsBlockGVCI4} from './CancerConditionGVCI4';
import {ChildhoodBenefitsBlock} from './ChildhoodBenefits';
import {CriticalIllnessConditionsBlock} from './CriticalIllnessCondition';
import {CriticalIllnessConditionsGVCI4Block} from './CriticalIllnessConditionGVCI4';
import {RecurrenceOfBenefitsForSameCriticalIllnessBlock} from './RecurrenceOfBenefitsForSameCriticalIllnessBlock';
import {SeperationPeriodForDifferentCriticalIllnessBlock} from './SeperationPeriodForDifferentCriticalIllnessBlock';

const GCI5Blocks: FormBlock[] = [
  {FormBlock: BenefitScheduleBlock, key: 'benefit-schedule-block'},
  {FormBlock: UnderwritingBlock, key: 'underwriting-block'},
  {
    FormBlock: SeperationPeriodForDifferentCriticalIllnessBlock,
    key: 'seperation-period-for-different-critical-illness-block',
    hidden: true,
  },
  {
    FormBlock: RecurrenceOfBenefitsForSameCriticalIllnessBlock,
    key: 'recurrence-of-benefits-for-same-critical-illness-block',
  },
  {
    FormBlock: CriticalIllnessConditionsBlock,
    key: 'critical-illness-condition-block',
  },
  {
    FormBlock: CancerConditionsBlock,
    key: 'cancer-condition-block',
  },
  {
    FormBlock: ChildhoodBenefitsBlock,
    key: 'childhood-benefits-block',
  },
  {
    FormBlock: AdditionalOptionsandBenefitsGCI5Block,
    key: 'additional-options-and-benefits-GCI5-block',
  },
];

const GVCI4Blocks: FormBlock[] = [
  {FormBlock: BenefitScheduleBlock, key: 'benefit-schedule-block'},
  {FormBlock: UnderwritingBlock, key: 'underwriting-block'},
  {
    FormBlock: SeperationPeriodForDifferentCriticalIllnessBlock,
    key: 'seperation-period-for-different-critical-illness-block',
    hidden: true,
  },
  {
    FormBlock: RecurrenceOfBenefitsForSameCriticalIllnessBlock,
    key: 'recurrence-of-benefits-for-same-critical-illness-block',
  },
  {
    FormBlock: CriticalIllnessConditionsGVCI4Block,
    key: 'critical-illness-condition-block',
  },
  {
    FormBlock: CancerConditionsBlockGVCI4,
    key: 'cancer-condition-block',
  },
  {
    FormBlock: AdditionalOptionsandBenefitsGVCI4Block,
    key: 'additional-options-and-benefits-GVCI4-block',
  },
];
const criticalIllnessBlocksMap: BlocksMap = new Map();
criticalIllnessBlocksMap.set('GCI5', GCI5Blocks);
criticalIllnessBlocksMap.set('GVCI4', GVCI4Blocks);

export const getCriticalIllnessBlocks = (plan: AvailablePlans) =>
  criticalIllnessBlocksMap.has(plan) ? [...commonBlocks, ...criticalIllnessBlocksMap.get(plan)] : [];
